import { gql, useQuery, useMutation } from "@apollo/client";
import { FormControl, TextField, Box, Button,
  Stack, Alert, Autocomplete, Tabs, Tab } from "@mui/material";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useEffect, useState as useReactState } from "react";
import { useState } from "../utils/useState";
import moment from "moment";
import { get, omit, has } from 'lodash'
import { useNavigate, useParams, useOutletContext } from "react-router-dom";
import { TrainingAttendance } from "./TrainingAttendance";
import { TrainingTags } from "./TrainingTags";
import { TrainingWhere } from "./TrainingWhere";
import { parseErrors } from "../utils/util";
import { TrainingForm } from "./TrainingForm";



export const Training = () => {
  const { setTitle } = useOutletContext();
  const navigate = useNavigate();
  let { id } = useParams()
  if (id) {
    id = parseInt(id)
  }
  const [attendance, setAttendance] = useReactState(0);
  const [totalCredits, setTotalCredits] = useReactState(0);

  const {data: config} = useQuery(gql`
    query {
      config_config {
        enable_booking
      }
    }
  `)

  const {data, refetch, loading} = useQuery(gql`
    query($id: Int!) {
      training(id: $id) {
        id,
        when,
        notes,
        commitment,
        venue_billing_type,
        venue_billing_config,
        limit,
        exempt_membership_count,
        disable_warning_emails,
        training_where {
          id,
          name,
          billing_type
        }
        training_tags {
          id,
          name
        },
        attendance,
        start_time,
        booking_offset,
        end_time,
        credit_amount,
        is_active
      }
    }
  `, {
    variables: {
      id: id
    },
    skip: !id
  })

  const parent_attendance = get(data, 'training.attendance', 0)

  useEffect(() => {
    if (!id) {
      setTitle("New Training");
    } else {
      setTitle(`Editing Training: ${get(data, 'training.training_where.name', id)} on ${get(data, 'training.when', '')}: ${attendance || parent_attendance}, ${totalCredits} credits`)
    }
  }, [get(data, 'training.training_where.name'), attendance, parent_attendance, totalCredits])

  const [{value}, setValue] = useState({value: (!id ? '1' : '2')}, {id: `trainings-tabs-${id}`});

  const attendanceAcc = attendance || parent_attendance;

  return <div>
    <Box sx={{display: 'flex', flexWrap: 'wrap' }}>
      <TabContext value={value}>
        <TabList sx={{width: '100%'}} onChange={(ev, newValue) => {
          setValue({value: newValue})
        }}>
          <Tab value={'1'} label="Training" />
          {id && <Tab value={'2'} label="Attendance" />}
        </TabList>
        <TabPanel value={'1'} sx={{width: '100%'}}>
          <TrainingForm
            id={id}
            data={data}
            loading={loading}
            config={config}
            refetch={refetch}
            attendanceAcc={attendanceAcc} />
        </TabPanel>
        {id &&
          <TabPanel value={'2'} sx={{width: '100%'}}>
            <TrainingAttendance setAttendance={setAttendance} setTotalCredits={setTotalCredits} trainingId={id} />
          </TabPanel>
        }
      </TabContext>
    </Box>
  </div>
}
